export enum BatteryStorageStatus {
  Exists = 'exists',
  Planned = 'planned',
  NotPlanned = 'not_planned',
}

export enum BatteryStorageUsage {
  Optimization = 'optimization',
  PeakShaving = 'peakShaving',
  AtypicalUsage = 'atypicalUsage',
  Arbitrage = 'arbitrage',
}
